@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/screen-width-breakpoints.module.less';
@import '../../../../../constants/spacing.module.less';

.connect-freight-provider-modal {
  @media @tablet, @desktop, @widescreen, @ultrawide {
    width: 500px;
  }
}

.modal-body {
  padding: @space-24;
}

.description {
  color: var(--default--text-color--17);
}

.modal-footer {
  padding: @space-16 @space-24;
  border-top: 1px solid var(--default--border-color--10);
}

.footer-buttons {
  justify-content: flex-end;
}
